import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import { useHomeLinks } from "../hooks/useNav";

function Footer() {
  const { homeLinks } = useHomeLinks();
  const footerLiks = [...homeLinks, {
    label: "Company",
    subcategories: [
      { label: "About Us", path: "/about-us/", header:true },
      { label: "Support", path: "https://support.knockthedoor.com/", header:true },
      { label: "Contact", path: "https://support.knockthedoor.com/", header:true },
      { label: "Blog", path: "https://www.knockthedoor.com/blog/", header:true},
    ],
  }];
  return (
    <div className="bg-borderColor font-linksans">
      <div className=" container mx-auto 2xl:py-10 py-8 md:py-10 xl:py-10 lg:py-10">
        <div className="grid 2xl:grid-cols-5 grid-cols-2 xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 gap-5 2xl:gap-8 xl:gap-6 lg:gap-4 justify-start">
          {footerLiks.map((link, index) => (
            <div key={index}>
              <h4 className="text-textColor hover:text-gray-600 md:text-base lg:text-base xl:text-base text-sm 2xl:text-base lg:pb-3 xl:pb-4 2xl:pb-4 pb-2.5 font-semibold">
                {link.label}
              </h4>
              <div className="flex flex-col gap-1.5 xl:gap-2.5 lg:gap-3.5 2xl:gap-3">
                {link.subcategories && link.subcategories.map((sublink, subIndex) => (
                  <div key={subIndex} className="text-textColor 2xl:text-base text-sm md:text-base lg:text-base xl:text-base hover:text-gray-600">
                    <div className="w-fit">
                      <div className="relative text-textColor cursor-pointer transition-all ease-in-out before:transition-[width] before:ease-in-out before:duration-300 before:absolute before:bg-gray-500 before:origin-center before:h-[1px] before:w-0 hover:before:w-[50%] before:bottom-0 before:left-[50%] after:transition-[width] after:ease-in-out after:duration-300 after:absolute after:bg-gray-500 after:origin-center after:h-[1px] after:w-0 hover:after:w-[50%] after:bottom-0 after:right-[50%]">
                        {sublink.path.startsWith('http') ? (
                          <Link 
                            rel="nofollow" 
                            target="_blank" 
                            to={sublink.path}
                            onClick={() => window.scrollTo(0, 0)}
                          >
                            {sublink.label}
                          </Link>
                        ) : sublink.path.includes('#') ? (
                          <HashLink 
                            to={sublink.path} 
                            onClick={() => window.scrollTo(0, 0)}
                          >
                            {sublink.label}
                          </HashLink>
                        ) : (
                          <Link 
                            to={sublink.path} 
                            onClick={() => window.scrollTo(0, 0)}
                          >
                            {sublink.label}
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-between lg:flex-row flex-col xl:flex-row 2xl:flex-row gap-8 2xl:gap-0 items-center mt-10">
          <div className="flex text-sm md:text-base lg:text-base xl:text-base 2xl:text-base md:flex-row md:flex-wrap  md:gap-6 items-center flex-col 2xl:flex-row gap-4 2xl:gap-14 text-paragraphColor">
            <h4>© {new Date().getFullYear()} Knock The Door Inc</h4>
            
            
            <Link target="_blank"  className="hover:underline" to="/disclosures">
            Disclosure
            </Link>
            <Link target="_blank" className="hover:underline" to="/privacy/">
              Privacy
            </Link>
            <Link target="_blank" className="hover:underline" to="/terms/">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
